import { render, staticRenderFns } from "./LatentDangerManage.vue?vue&type=template&id=618f8e3c&scoped=true&"
import script from "./LatentDangerManage.vue?vue&type=script&lang=js&"
export * from "./LatentDangerManage.vue?vue&type=script&lang=js&"
import style0 from "./LatentDangerManage.vue?vue&type=style&index=0&id=618f8e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618f8e3c",
  null
  
)

export default component.exports